import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { endpoint } from '../../utils/endpoints';
import { handleApiCall } from '../../apis';
import { FaCalendarAlt } from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CustomDatePicker from '../../Components/CustomDatePicker';
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { toast } from 'react-toastify';
import Toastify from '../../utils/tostfy';
import TeacherCharts from '../UserManagement/TeacherCharts'
import demppic from "../../assets/image/user-circle.svg"
import Loader from '../../Components/Loader/Loader';


const CoachView = () => {
    const totalPage = 2;
    const location = useLocation();
    const navigate = useNavigate();

    const [page, setPage] = useState(0);
    const [event, setEvent] = useState();
    const [graphdata, setgraphdata] = useState();
    const [scheduleSessionList, setscheduleSessionList] = useState([]);
    const [observation, setObservationList] = useState([]);
    const [sessionData, setSessionData] = useState({ completed: [], upcoming: [] });
    const [filter, setFilter] = useState(1);
    const [isOpen, setIsOpen] = useState({
        section1: true,
        section2: true,
        section3: false,
    });

    const [date, setDate] = useState();
    const [inner, setinner] = useState("")
    const [selectedDate, setselectedDate] = useState();
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [showCustomPicker, setShowCustomPicker] = useState(false);
    const [loading, setLoading] = useState(true);

    const dropdownRef = useRef(null);

    const toggleSection = (section) => {
        setIsOpen((prevState) => ({
            ...prevState,
            [section]: !prevState[section],
        }));
    };

    const goBack = () => {
        navigate(-1);
    };

    const handleOptionClick = (option) => {
        setSelectedOption(option);
        if (option === 'custom_date') {
            setShowCustomPicker(true);
        } else {
            setShowCustomPicker(false);
            setFromDate(null);
            setToDate(null);
        }
        setShowDropdown(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
                setShowCustomPicker(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (selectedOption === 'custom_date' && fromDate && toDate) {
            const timeout = setTimeout(() => {
                setShowCustomPicker(false);
                setShowDropdown(false);
            }, 300);
            return () => clearTimeout(timeout);
        }
    }, [fromDate, toDate, selectedOption]);

    useEffect(() => {
        getUserDetails();
        getCalender();
        getAssignedTeacher();
        getObservationList(1);
        getTeacherSehList(1);
    }, []);

    // useEffect(() => {
    //     if (fromDate && toDate) {
    //         getObservationList(null, fromDate, toDate);
    //         getTeacherSehList(null, fromDate, toDate);
    //         getUserDetails(null, fromDate, toDate); // ✅ Add this
    //         setFilter(1);
    //     }
    // }, [fromDate, toDate]);


    const getUserDetails = async (filterVal = filter, from = null, to = null) => {
        let url = `${endpoint.viewCoach}?id=${location?.state?.id}`;

        if (from && to) {
            url += `&from_date=${ApiDate(from)}&to_date=${ApiDate(to)}&filter=3`;
            setinner(`&from_date=${ApiDate(from)}&to_date=${ApiDate(to)}&filter=3`)
        } else if (date) {
            url += `&selected_date=${ApiDate(date)}`;
            setinner(`&from_date=${ApiDate(from)}&to_date=${ApiDate(to)}&filter=3`)
        } else if (filterVal && filterVal !== "custom_date") {
            url += `&filter=${filterVal}`;
            setinner(`&filter=${filterVal}`)
        }

        try {
            const response = await handleApiCall("get", url);
            if (response?.data?.code === 200) {
                setEvent(response?.data?.data);
                setgraphdata(response?.data?.data?.teacher_piority_graph?.current_priority_area);
            }
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        getTeacherSehList()
    }, [date])





    const getTeacherSehList = async (filterVal = filter, from = null, to = null) => {
        let url = `${endpoint.coacheTeacherListSeh}?id=${location?.state?.id}`;
        if (from && to) {
            url += `&from_date=${ApiDate(from)}&to_date=${ApiDate(to)}&filter=3`;
        } else if (date) {
            url += `&selected_date=${ApiDate(date)}`;
        } else if (filterVal && filterVal !== "custom_date") {
            url += `&filter=${filterVal}`;
        }

        try {
            const response = await handleApiCall("get", url);
            if (response?.data?.code === 200) {
                setLoading(false);
                setscheduleSessionList(response?.data?.data?.scheduleSessionList);
            } else if (response?.response?.data?.success === false) {
                setLoading(false);
                toast.error(response?.response?.data?.errorMessage);
                setTimeout(() => navigate("/"), 2000);
            }
        } catch (e) {
            setLoading(false);
            console.log(e);
        }
    };

    const getObservationList = async (filterVal = filter, from = null, to = null) => {
        let url = `${endpoint.listObservation}?id=${location?.state?.id}`;
        if (from && to) {
            url += `&from_date=${ApiDate(from)}&to_date=${ApiDate(to)}&filter=3`;
        } else if (filterVal && filterVal !== "custom_date") {
            url += `&filter=${filterVal}`;
        } else {
            return;
        }

        try {
            const response = await handleApiCall("get", url);
            if (response?.data?.code === 200) {
                setObservationList(response?.data?.data?.observationList);
            }
        } catch (e) {
            console.error("Error fetching observation list:", e);
        }
    };

    const getAssignedTeacher = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.assignedTeacherList}?id=${location?.state?.id}`);
            if (response?.data?.code === 200) {
                console.log(response, "Assigned Teachers");
            }
        } catch (e) {
            console.log(e);
        }
    };

    const getCalender = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.coachCalender}?id=${location?.state?.id}`);
            if (response?.data?.success) {
                const scheduleList = response?.data?.data?.scheduleSessionList;
                const completed = [];
                const upcoming = [];

                Object.entries(scheduleList).forEach(([date, details]) => {
                    if (details.schedule_status === 1) completed.push(date);
                    else if (details.schedule_status === 2) upcoming.push(date);
                });

                setSessionData({ completed, upcoming });
            }
        } catch (e) {
            console.log(e);
        }
    };

    const ApiDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const tileContent = ({ date, view }) => {
        if (view === "month") {
            const formattedDate = date.toLocaleDateString("en-CA");
            if (sessionData.completed.includes(formattedDate)) {
                return <span className="dot bg-[#994263]"></span>;
            }
            if (sessionData.upcoming.includes(formattedDate)) {
                return <span className="dot bg-[#E9A93A]"></span>;
            }
        }
        return null;
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'short' });
        let hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        return `${day} ${month}, ${hours.toString().padStart(2, '0')}:${minutes} ${ampm}`;
    };
    return (
        <>
            <Toastify />
            <Loader isLoading={loading} /> {/* Call Loader */}
            <div className=' imagebox image flex justify-between items-center'>
                <div className=' flex gap-2 items-center'>
                    <img src={event?.coachData?.image || demppic} alt="user" className="w-16 h-16 rounded-full" />
                    <div className=' flex-col'>
                        <p className=' font-bold '>  {event?.coachData?.full_name} </p>
                        <p className=' text-gray-500'>Coach</p>
                    </div>

                </div>
                <div className=' '>
                    <Link onClick={goBack} className="text-white bg-black hover:text-white outline-1 outline-double rounded-md text-sm font-semibold px-4 py-2 d-inline-block">Back</Link>

                </div>
            </div>
           

            <div className=' allSection mt-3'>
                <div className="grid grid-cols-2 md:grid-cols-7 sm:grid-cols-3 gap-3 my-2 ">

                    <div className="border rounded-2 d-flex flex-column py-2 px-2 bg-[#FFCC4E] bg-opacity-40 cursor-pointer " onClick={() => navigate("/coach-management/view-coach/coach-TotalSession", { state: { coach: event?.coachData, filter: inner } })}>
                        <span className="font-bold text-xl text-black text-wrap text-center">{event?.sessionCount || "NA"}</span>
                        <span className=" text-sm text-gray-500 text-wrap text-center my-2">Total Session This <br />Month</span>

                    </div>
                    <div className="border rounded-2 d-flex flex-column py-2 px-2 bg-[#FFCC4E] bg-opacity-40 cursor-pointer " onClick={() => navigate("/coach-management/view-coach/coach-TotalProgress", { state: { coach: event?.coachData, filter: inner } })}>
                        <span className="font-bold text-xl text-black text-wrap text-center">{event?.teacherSessionProgress || "NA"}</span>
                        <span className=" text-sm text-gray-500 text-wrap text-center my-2">Teacher Session<br />Progress</span>

                    </div>
                    <div className="border rounded-2 d-flex flex-column py-2 px-2 bg-[#FFCC4E] bg-opacity-40 cursor-pointer " onClick={() => navigate("/coach-management/view-coach/coach-VisitedSchool", { state: { coach: event?.coachData, filter: inner } })}>
                        <span className="font-bold text-xl text-black text-wrap text-center">{event?.schoolVisitProgress || "NA"}</span>
                        <span className=" text-sm text-gray-500 text-wrap text-center my-2">School Visit<br />Progress</span>

                    </div>
                    {/* <div className="border rounded-2 d-flex flex-column py-2 px-2 h-16 bg-[#994263]  cursor-pointer "onClick={() => navigate("/coach-management/view-coach/coach-VisitedSchool", { state: {coach: event?.coachData } })}>
                  
                        <span className=" text-sm text-white font-bold text-wrap text-center ">View<br />Assigned Teacher</span>

                    </div> */}


                </div>

                <div className=' flex justify-end'> 
                <div className="relative" ref={dropdownRef}>
                        <button
                            onClick={() => {
                                setShowDropdown((prev) => !prev);
                                setShowCustomPicker(false); // hide custom picker if toggling dropdown
                            }}
                            className="p-2 bg-[#F6F6F6] border border-black rounded-md"
                        >
                            <FaCalendarAlt size={20} />
                        </button>

                        {showDropdown && (
                            <div className="absolute right-0 mt-2 bg-white border border-gray-300 rounded shadow-md z-10 w-56">
                                <button
                                    onClick={() => {
                                        setFilter(1);
                                        setShowDropdown(false);
                                        getObservationList(1);
                                        getTeacherSehList(1)
                                        getUserDetails(1)
                                    }}
                                    className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                >
                                    This Month
                                </button>
                                <button
                                    onClick={() => {
                                        setFilter(2);
                                        setShowDropdown(false);
                                        getObservationList(2);
                                        getTeacherSehList(2)
                                        getUserDetails(2)
                                    }}
                                    className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                >
                                    Last 3 Months
                                </button>
                                <button
                                    onClick={() => {
                                        setShowCustomPicker(true);
                                        setShowDropdown(false);
                                        setFromDate(null); // optional: clear old selections
                                        setToDate(null);
                                    }}
                                    className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                >
                                    Custom Date
                                </button>
                            </div>
                        )}

                        {/* ✅ Show custom date picker when enabled */}
                        {showCustomPicker && (
                            <div className="absolute right-0 mt-2 bg-white px-4 pt-3 pb-4 border border-black rounded-md shadow-md z-20 w-[320px] text-sm">

                                {/* Cancel X button */}
                                <div className="flex justify-end mb-2">
                                    <button
                                        onClick={() => {
                                            setFromDate(null);
                                            setToDate(null);
                                            setShowCustomPicker(false);
                                            setShowDropdown(false);
                                        }}
                                        className="w-6 h-6 text-white text-xl font-bold hover:text-red-800 border border-[#994263] bg-[#994263] rounded-full flex items-center justify-center"
                                        title="Cancel"
                                    >
                                        ×
                                    </button>
                                </div>

                                {/* Date fields */}
                                <div className="flex flex-col gap-2">
                                    {/* FROM DATE */}
                                    <div className="flex flex-col">
                                        <label className="mb-1 font-medium">From:</label>
                                        <CustomDatePicker
                                            selected={fromDate}
                                            onChange={(date) => {
                                                setFromDate(date);
                                                setToDate(null);   // reset TO date when FROM changes
                                            }}
                                            placeholder="Select from date"
                                            dateFormat="yyyy-MM-dd"
                                            maxDate={new Date()}
                                        />
                                    </div>

                                    {/* TO DATE */}
                                    <div className="flex flex-col">
                                        <label className="mb-1 font-medium">To:</label>
                                        <CustomDatePicker
                                            selected={toDate}
                                            onChange={(date) => setToDate(date)}
                                            placeholder="Select to date"
                                            dateFormat="yyyy-MM-dd"
                                            minDate={fromDate || null}
                                            maxDate={
                                                fromDate
                                                    ? new Date(
                                                        Math.min(
                                                            new Date().getTime(),
                                                            fromDate.getTime() + 89 * 24 * 60 * 60 * 1000
                                                        )
                                                    )
                                                    : new Date()
                                            }
                                        />
                                    </div>
                                </div>

                                {/* Submit button */}
                                {fromDate && toDate && (
                                    <button
                                        onClick={() => {
                                            getObservationList(null, fromDate, toDate);
                                            getTeacherSehList(null, fromDate, toDate);
                                            getUserDetails(null, fromDate, toDate);
                                            setFilter(1);
                                            setShowCustomPicker(false);
                                            setShowDropdown(false);
                                        }}
                                        className="mt-3 w-full py-1.5 bg-[#994263] text-white rounded-md hover:bg-gray-900 transition"
                                    >
                                        Submit
                                    </button>
                                )}
                            </div>
                        )}




                    </div>
            </div>


                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4 ">
                    <div className="bg-[#E5DED4] bg-opacity-25 p-4 rounded-md md:col-span-2 lg:col-span-1">
                        <p className="font-bold text-[13px] text-black">Teacher Priority Area Over Time</p>
                        <TeacherCharts data={graphdata} coachData={event?.coachData} />

                    </div>

                    <div class="  rounded-md  flex flex-col items-center  custom-scrollbar mt-4">
                        <div className=' flex justify-start gap-3 mb-1 items-center'>
                            <div className=' flex gap-2 items-center'><span className="rounded-full w-2 h-2 bg-[#994263]"></span><p className="font-bold text-[13px] text-black" >Completed Session</p></div>
                            <div className=' flex gap-2 items-center'><span className="rounded-full w-2 h-2 bg-[#FFCC4E]"></span><p className="font-bold text-[13px] text-black" >Upcoming Session</p></div>

                        </div>
                        <Calendar
                            onChange={setDate}
                            value={date}
                            tileContent={tileContent}
                            className="custom-calendar"
                        />

                    </div>
                    <div className="  p-4  rounded-md">
                        <p className="font-bold text-[13px] text-black mb-1">Teacher Schedule </p>
                        {scheduleSessionList?.length > 0 ? <div className="max-h-[200px]  overflow-y-auto pr-1 custom-scrollbar">
                            <div className="flex flex-col gap-y-2">
                                {scheduleSessionList?.map((item, index) => (
                                    <div key={index} className="bg-[#E5DED4] bg-opacity-25 flex-col rounded-lg p-2">
                                        <div className="flex justify-between px-2 items-center">
                                            <div className="flex gap-2 text-center items-center">
                                                <img className="rounded-full w-4 h-4 " src={item?.teacher_image || demppic}></img>
                                                <p className="text-sm">{item?.teacher_full_name || "NA"}</p>
                                            </div>
                                            <div className="text-[12px]">{formatDate(item.schedule_date_time) || "NA"}</div>
                                        </div>
                                        <div className="ml-8 mt-1">
                                            <p className="text-[12px] text-gray-400">
                                                {item.school_name || "NA"} <br />
                                                {item.school_address || "NA"}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div> : <div className="flex flex-col gap-y-2">
                            No Teacher Schedule
                        </div>}


                    </div>
                </div>
            </div>
          



            <div className=' allSection mt-3 p-4'>
                <div className="flex justify-between items-center w-full mb-2">
                    <p className="text-black font-bold text-[22px]">History</p>

                    
                </div>


                {observation?.length > 0 ? <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {observation?.map(item => (
                        <div class=" flex-col rounded-md p-2">

                            <div className=' bg-[#E5DED4] bg-opacity-25 rounded-md p-2 min-h-72'>
                                <div className=' flex justify-between mx-2'>
                                    <p className=' text-gray-500 text-[12px] '>Coach Session Feedback</p>
                                    <p className=' text-gray-500 text-[12px]'>Lesson:{item?.actual_lession} * {formatDate(item?.created_date)}</p>
                                </div>
                                <div className=' flex gap-2 items-center px-2 mt-2'>
                                    <img className="rounded-full w-4 h-4 " src={item?.teacher_image || demppic}></img>
                                    <p className=' text-black text-[12px]'>{item?.teacher_full_name}</p>
                                </div>
                                <p className=' text-gray-500 text-[12px] p-2 text' >{item?.observation_ai_feedback?.summary}</p>
                                <hr className="border-t border-gray-400 my-2" />



                                <div className='bg-[#F0D7E0] p-2 rounded-lg'>


                                    {item?.observation_action_plan?.length > 0 ? (
                                        item?.observation_action_plan?.map((item, index) => (
                                            <p key={index} className='font-bold text-[12px]'>- {item?.action_plan_name}</p>
                                        ))
                                    ) : (
                                        <p className='text-[12px] font-semibold text-gray-600'>No Action Plans</p>
                                    )}
                                </div>


                            </div>
                            <div className=' flex justify-end'>
                                <button onClick={() => navigate("/coach-management/view-coach/coach-Feedback", { state: { id: item?._id, coach: event?.coachData } })} className=' font-bold text-[#994263]'>See session details</button>
                            </div>


                        </div>
                    ))}


                </div> : <p className=' text-center mt-2 font-bold border-t-2  py-4'>No History Found</p>}



            </div>

        </>
    );
}

export default CoachView;
